<div *ngIf="showModal">
    <div class="modal-header">
        <h5 class="mb-0">{{ title | translate }} {{ (item?.id ? 'common.edit' : 'common.create') | translate }}</h5>
    </div>
    <div class="modal-body">
        <form class="k-form k-form-md" [formGroup]="form">
            <div class="mb-1 row">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label controlName="name" class="col-form-label">{{ 'partner.name' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-10 col-xl-10">
                    <input type="text" id="name" formControlName="name" class="form-control" />
                    <app-field-error-message controlName="name"></app-field-error-message>
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label controlName="email" class="col-form-label">{{ 'partner.email' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-10 col-xl-10">
                    <input type="email" id="email" formControlName="email" class="form-control" />
                    <app-field-error-message controlName="email"></app-field-error-message>
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label controlName="phoneNumber" class="col-form-label">{{ 'partner.phone_number' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-10 col-xl-10">
                    <input type="text" id="phoneNumber" formControlName="phoneNumber" class="form-control" />
                    <app-field-error-message controlName="phoneNumber"></app-field-error-message>
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label controlName="websiteUrl" class="col-form-label">{{ 'partner.website_url' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-10 col-xl-10">
                    <input type="text" id="websiteUrl" formControlName="websiteUrl" class="form-control" />
                    <app-field-error-message controlName="websiteUrl"></app-field-error-message>
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label controlName="gpsCoordinate" class="col-form-label">{{ 'partner.gps_coordinate' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-10 col-xl-10">
                    <input type="text" id="gpsCoordinate" formControlName="gpsCoordinate" class="form-control" />
                    <app-field-error-message controlName="gpsCoordinate"></app-field-error-message>
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label controlName="description" class="col-form-label">{{ 'common.description' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-10 col-xl-10">
                    <textarea id="description" formControlName="description" class="form-control" rows="3"></textarea>
                    <app-field-error-message controlName="description"></app-field-error-message>
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-md-2 col-xl-2">
                   <app-label class="col-form-label">
                        {{ 'partner.brand_image' | translate }} <span class="text-danger">*</span> <br>(h: 300px)
                    </app-label>    
                </div>
                <div class="col-12 col-md-4 col-xl-4">
                    <input type="file" id="brandImage-file-input" (change)="onFileSelected($event, 'brandImage')" class="form-control" accept=".png,.jpg,.jpeg" />
                </div>
                <div class="col-12 col-md-2 col-xl-2">
                    <img class="app-image-fix-width-30px" id="selected-brandImage" />
                </div>
                <div class="col-12 col-md-2 col-xl-2">
                    <button class="btn btn-secondary" (click)="onClearImage('brandImage')">{{ 'common.clear' | translate }}</button>
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label class="col-form-label">{{ 'partner.cover_image' | translate }} <span class="text-danger">*</span> <br>(h: 300px)</app-label>
                </div>
                <div class="col-12 col-md-4 col-xl-4">
                    <input type="file" id="coverImage-file-input" (change)="onFileSelected($event, 'coverImage')" class="form-control" accept=".png,.jpg,.jpeg" />
                </div>
                <div class="col-12 col-md-2 col-xl-2">
                    <img class="app-image-fix-width-30px" id="selected-coverImage" />
                </div>
                <div class="col-12 col-md-2 col-xl-2">
                    <button class="btn btn-secondary" (click)="onClearImage('coverImage')">{{ 'common.clear' | translate }}</button>
                </div>
            </div>
            <hr />
            <div class="my-1 row">
                <div class="d-flex justify-content-end align-items-center mb-1 w-100">
                    <div class="d-flex gap-4">
                        <button type="submit" [appClickWait]="onSave" class="btn btn-primary w-100" themeColor="primary">
                            {{ 'common.save' | translate }}
                        </button>
                        <button class="btn btn-secondary w-100" (click)="onClose()">
                            {{ 'common.cancel' | translate }}
                        </button>
                        <button *ngIf="showDeleteButton" type="submit" [appClickWait]="onDeleteConfirm" class="btn btn-warning" themeColor="primary">
                            {{ 'common.inactivate_item' | translate }}
                        </button>
                        <button *ngIf="showUndeleteButton" type="submit" [appClickWait]="onDeleteConfirm" class="btn btn-success" themeColor="primary">
                            {{ 'common.activate_item' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
